<template>
<div class="pay-page">
  <myHeader :title="title"></myHeader>
  <div class="pay-info">
    <p>订单号：{{order_number}}</p>
    <p>
      应付金额：
      <icon-price></icon-price>
      {{order_price | toFixPrice}}
    </p>
  </div>
  <van-radio-group v-model="radio">
    <van-cell-group>
      <van-cell title="金币支付" clickable>
        <!-- <i class="pay-other" slot="icon" /> -->
        <icon-price slot="icon"></icon-price>
        <van-radio slot="right-icon" name="1" :checked-color="$theme_color" />
      </van-cell>
    </van-cell-group>
  </van-radio-group>
  <div class="price-btn">
    <p class="default">实付价格</p>
    <icon-price size="mini"></icon-price>
    <p class="price">{{order_price | toFixPrice}}</p>
    <van-button @click="onPay">提交订单</van-button>
  </div>
</div>
</template>

<script>
import myHeader from "@/components/Header";
export default {
  name: "AppPay",
  components: {
    myHeader
  },
  data() {
    return {
      title: {
        name: "订单支付"
      },
      order_price: this.$route.query.order_price / 1,
      order_number: this.$route.query.order_number,
      type: this.$route.query.type,
      radio: "1"
    };
  },
  computed: {
    app() {
      return this.$store.state.app;
    }
  },
  methods: {
    /**
     * 支付
     *  */
    onPay() {
      // app提交参数
      let params = {
        orderNumber: this.order_number,
        shop_id: this.$route.query.shop_id,
        payType: "money",
        price: this.order_price
      };
      this.$pub.appAction("pay", params);
    }
  },
  /**
   *  微信内支付检测
   */
  created() {
    // app回调监听
    if (this.app) {
      this.$pub.registerWebViewJavascriptBridge(() => {
        this.$pub.ToOrder(this.type);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-page {
    @extend %default-bg;
    .pay-info {
        width: 710px;
        height: 200px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        text-align: center;
        margin: 30px auto;
        padding: 40px;
        box-sizing: border-box;
        line-height: 60px;
        p {
            &:nth-child(1) {
                font-size: 28px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(89, 89, 89, 1);
            }
            &:nth-child(2) {
                font-size: 34px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: rgba(89, 89, 89, 1);
            }
        }
    }
    .pay-wx {
        width: 60px;
        height: 100%;
        background: url("../../assets/images/pay-wx.png") no-repeat left center;
        background-size: 48px 38px;
    }
    .pay-other {
        width: 60px;
        height: 100%;
        background: url("../../assets/images/pay-other.png") no-repeat left center;
        background-size: 34px 44px;
    }
    .pay-img {
        width: 60px;
        height: 100%;
        background: url("../../assets/images/pay-zhifubao.png") no-repeat left center;
        background-size: 38px 38px;
    }
    /deep/ .van-radio__icon .van-icon {
        font-size: 24px;
    }
}
.price-ico {
    width: 24px;
}
.price-btn {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    p.default {
        font-family: PingFangSC-Medium;
        color: #8c8c8c;
        font-size: 20px;
        padding: 10px 4px 0 48px;
    }
    p.price {
        color: #e02020;
        font-size: 46px;
        flex: 1;
        margin-left: 2px;
    }
    img {
        width: 20px;
        margin-top: 10px;
    }
    button {
        width: 270px;
        height: 108px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        font-size: 36px;
        text-align: center;
        line-height: 108px;
        background: $theme_color;
        border: 0;
    }
}
</style>
